module.exports = __webpack_public_path__ + "assets/img/286101.3e63e125.png";